export enum SongState {
    None,
    Loading,
    Playing,
    Paused,
    Stopped,
    Done,
    Error
};